import { Injectable } from '@angular/core';
import { BotService } from './bot.service';
import { KeyValAdminService } from './key-val-admin.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';

@Injectable({
  providedIn: 'root'
})
export class SupervisorManagerService {

  constructor(
    private botService: BotService,
    private keyValService: KeyValAdminService,
    private botIdService: BotidService
  ) { }

  public async notify(messageName: string, historyItemId: string = "") {
    await this.botService.supervisorNotification(this.botIdService.getBotId(), historyItemId, messageName);
  }

  public setInfo(key: string, value: unknown) {
    return this.keyValService.storeKeyValEntry(key, value, "supervisor");
  }

  public async getInfo(key: string) {
    return (await this.keyValService.getKeyValByType("supervisor")).find(obj => obj.key === key)?.value ?? null;
  }
}
